<template>
  <dialog-v2
    :show="dialog"
    :title="companyLoad.name || ''"
    max-width="620px"
    :save-button="!!saveButtonText"
    :save-button-text="saveButtonText"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <template v-for="(detail, i) in details">
        <v-layout
          row
          wrap
          justify-space-between
          align-center
          :mb-2="i !== (details.length - 1) && (detail.status === 'Pendiente' || detail.status === 'Detenido')"
          :key="`detail-${i}`">
          <v-flex md1 v-if="enableChecks">
            <v-checkbox
              v-model="detail.restartFrom"
              @change="setRestartFrom(detail)"
              :disabled="detail.status === 'Detenido' || detail.status === 'Pendiente'"
              hide-details
              class="k-orange-linear-text"
              small />
          </v-flex>
          <v-flex md1 text-xs-center>
            <v-tooltip bottom
              v-if="detail.status === 'Pendiente'">
              <v-icon
                slot="activator"
                color="blue"
                small>
                far fa-clock
              </v-icon>
              <span>Pendiente</span>
            </v-tooltip>
            <v-tooltip bottom
              v-else-if="detail.status === 'En proceso'">
              <v-icon
                slot="activator"
                color="blue"
                small>
                fas fa-circle-notch fa-spin
              </v-icon>
              <span>En proceso</span>
            </v-tooltip>
            <v-tooltip bottom
              v-else-if="detail.status === 'Error'">
              <v-icon
                slot="activator"
                color="red"
                small>
                fas fa-times-circle
              </v-icon>
              <span>Error</span>
            </v-tooltip>
            <v-tooltip bottom
              v-else-if="detail.status === 'Advertencia'">
              <v-icon
                slot="activator"
                color="yellow"
                small>
                fas fa-exclamation-triangle
              </v-icon>
              <span>Advertencia</span>
            </v-tooltip>
            <v-tooltip bottom
              v-else-if="detail.status === 'Detenido'">
              <v-icon
                slot="activator"
                color="red"
                small>
                fas fa-stop-circle
              </v-icon>
              <span>Detenido</span>
            </v-tooltip>
            <v-tooltip bottom
              v-else>
              <v-icon
                slot="activator"
                color="green"
                small>
                fas fa-check-circle
              </v-icon>
              <span>Finalizado</span>
            </v-tooltip>
          </v-flex>
          <v-flex
            :md7="detail.status !== 'Pendiente' && detail.status !== 'Detenido' && detail.status !== 'En proceso' && !enableChecks"
            :md6="detail.status !== 'Pendiente' && detail.status !== 'Detenido' && detail.status !== 'En proceso' && enableChecks"
            :md10="(detail.status === 'Detenido' || detail.status === 'Pendiente') && enableChecks">
            <h3 class="font-weight-normal">
              {{ detail.name }}
            </h3>
          </v-flex>
          <v-flex md3 v-if="detail.status === 'Finalizado' || detail.status === 'Error' || detail.status === 'Advertencia'">
            ({{ getTimeLapsed(detail.start_at, detail.end_at) }})
          </v-flex>
          <v-flex
            v-if="detail.status !== 'Pendiente' && detail.status !== 'Detenido'"
            md1
            text-xs-center>
            <v-btn small icon @click="detail.showLog = !detail.showLog">
              <v-icon v-if="!detail.showLog">
                fas fa-angle-down
              </v-icon>
              <v-icon v-else>
                fas fa-angle-up
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-slide-y-transition v-if="detail.status !== 'Pendiente' && detail.status !== 'Detenido'" :key="`log-${i}`">
          <v-layout mb-2 v-show="detail.showLog">
            <v-flex md12 pr-2 pl-2>
              <pre class="pa-2">
                <p class="mb-0" v-for="(item, b) in detail.logs" :key="`log-${i}-${b}`">
                  {{ formatDate(item.created_at) }} {{ item.descrip }}
                </p>
              </pre>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>
      </template>
      <v-layout v-if="enableChecks" row wrap mt-2>
        <v-flex>
          <small v-if="warningMessageType <= 1">
            Seleccione desde que paso de la carga desea reiniciar
          </small>
          <small class="error--text" v-else>
            Debe seleccionar un paso para poder reiniciar
          </small>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import moment from 'moment-timezone';
import DialogV2 from '@/components/global/DialogV2';
import axios from 'axios';
import EventBus from '@/event-bus';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    companyLoad: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  created() {
    moment.locale('es');
  },
  destroyed() {
    this.stopListening();
  },
  data() {
    return {
      details: [],
      dialog: false,
      enableChecks: false,
      restartFrom: null,
      warningMessageType: 0,
    };
  },
  computed: {
    companyLoadStatus() {
      let status = '';

      const toStart = this.details.length === this.details.filter(item => item.status === 'Pendiente').length;
      if (toStart) {
        status = 'toStart';
      } else {
        const toStop = this.details.find(item => item.status === 'En proceso') && !this.details.find(item => item.status === 'Detenido');
        if (toStop) {
          status = 'toStop';
        } else {
          const toRestart = this.details.length === this.details.filter(item => item.status === 'Finalizado' || item.status === 'Advertencia' || item.status === 'Detenido' || item.status === 'Error' || item.status === 'Pendiente').length;
          if (toRestart) {
            status = 'toRestart';
          }
        }
      }
      return status;
    },
    saveButtonText() {
      let text = '';
      if (this.companyLoadStatus === 'toStart') {
        text = 'Iniciar carga';
      } else if (this.companyLoadStatus === 'toStop') {
        text = 'Detener carga';
      } else if (this.companyLoadStatus === 'toRestart') {
        text = 'Reiniciar carga';
      }
      return text;
    },
  },
  methods: {
    startListening() {
      window.Echo.private(`companyLoad.${this.companyLoad.id}`)
        .listen('.DetailUpdated', (event) => {
          // eslint-disable-next-line
          const index = this.details.findIndex(item => item.id === event.load_stage_id);
          this.$set(this.details, index, {
            ...this.details[index],
            ...event,
          });
        })
        .listen('.LogCreated', (event) => {
          // eslint-disable-next-line
          const index = this.details.findIndex(item => item.load_stage_detail_id === event.load_stage_detail_id);
          const { logs } = this.details[index];
          logs.push(event);
          this.$set(this.details, index, {
            ...this.details[index],
            logs,
          });
        });
    },
    stopListening() {
      window.Echo.leave(`companyLoad.${this.companyLoad.id}`);
    },
    getTimeLapsed(startAt, endAt) {
      const start = moment.utc(startAt);
      const end = moment.utc(endAt);
      const diff = end.diff(start);
      return moment.duration(diff).humanize();
    },
    formatDate(date) {
      return moment.utc(date).local().format('hh:mm:ss A');
    },
    save() {
      if (this.companyLoadStatus === 'toStart') {
        this.startLoad();
      } else if (this.companyLoadStatus === 'toStop') {
        this.stopLoad();
      } else if (this.companyLoadStatus === 'toRestart' && !this.restartFrom) {
        this.enableChecks = true;
        this.warningMessageType += 1;
      } else {
        this.restartLoad();
      }
    },
    setRestartFrom(detail) {
      if (detail.restartFrom) {
        this.restartFrom = detail.id;
      } else {
        this.restartFrom = null;
      }
    },
    startLoad() {
      const axiosInstance = axios.create();
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('default_auth_token')}`;

      axiosInstance.post(`/company_loads/${this.companyLoad.id}/commute`, {
        action: 'start',
      }).then(() => {
      }).catch((error) => {
        let errorMessage = '';
        if(error.response && error.response.data && error.response.data.errors){
          errorMessage = error.response.data.errors.load[0] || 'Error inesperado';
        }else{
          errorMessage = 'Error inesperado';
        }
        this.$store.commit('SET_TOAST_NOTIFICATION', {
            variant: 'error',
            title: `Error de carga diaria`,
            message: errorMessage,
          });
        this.stopListening();
      });
    },
    stopLoad() {
      this.axios.post(`company_loads/${this.companyLoad.id}/commute`, {
        action: 'stop',
      }).then(() => {
        const pendingDetails = this.details.filter(item => item.status === 'Pendiente');
        for (let i = 0; i < pendingDetails.length; i += 1) {
          const index = this.details.findIndex(item => item.id === pendingDetails[i].id);
          this.$set(this.details, index, {
            ...this.details[index],
            status: 'Detenido',
          });
        }
      }).catch((error) => {
        console.log(error);
        this.$vs.notify({
              title: 'Error',
              text: 'Error inesperado, intente de nuevo mas tarde',
              color: 'danger',
              icon: 'error',
              position: 'bottom-right',
            });
      });
    },
    restartLoad() {
      this.enableChecks = false;

      const axiosInstance = axios.create();
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('default_auth_token')}`;

      axiosInstance.post(`company_loads/${this.companyLoad.id}/commute`, {
        action: 'restart',
        from: this.restartFrom,
      }).then(() => {
        const order = (this.details.find(item => item.id === this.restartFrom) || []).order || 1;
        const restartedDetails = this.details.filter(item => item.order >= order);
        for (let i = 0; i < restartedDetails.length; i += 1) {
          const index = this.details.findIndex(item => item.id === restartedDetails[i].id);
          this.$set(this.details, index, {
            ...this.details[index],
            status: 'Pendiente',
            descrip: null,
            start_at: null,
            end_at: null,
            logs: [],
          });
        }
        this.restartFrom = null;
      }).catch((error) => {
        let errorMessage = '';
        if(error.response && error.response.data && error.response.data.errors){
          errorMessage = error.response.data.errors.load[0] || 'Error inesperado';
        }else{
          errorMessage = 'Error inesperado';
        }
        this.$store.commit('SET_TOAST_NOTIFICATION', {
            variant: 'error',
            title: `Error de carga diaria`,
            message: errorMessage,
          });
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.axios.get(`company_loads/${this.companyLoad.id}/details`).then((response) => {
          this.details = response.data.map(item => ({
            ...item,
            showLog: false,
            restartFrom: false,
          }));
          this.startListening();
          this.dialog = this.show;
        }).catch(() => {});
      } else {
        this.dialog = this.show;
        this.enableChecks = false;
        this.stopListening();
      }
    },
    enableChecks() {
      if (!this.enableChecks) {
        this.warningMessageType = 0;
      }
    },
    restartFrom() {
      for (let i = 0; i < this.details.length; i += 1) {
        this.$set(this.details, i, {
          ...this.details[i],
          restartFrom: this.details[i].id === this.restartFrom,
        });
      }
    },
  },
};
</script>

<style scoped>
pre {
  overflow-y: auto;
  min-height: 50px;
  max-height: 200px;
}
pre p {
  font-size: 11px;
  margin-bottom: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/CompanyLoad/Detail.vue